import clsx from 'clsx';
import type { LucideIcon } from 'lucide-react';

/** Libellé d'un rôle précédé de son picto (roleIcons) */
export function RoleLabel({ icon: Icon, label, className }: { icon: LucideIcon; label: string; className?: string }) {
  return (
    <span className={clsx('inline-flex items-center gap-1', className)}>
      <Icon className="w-3.5 h-3.5 shrink-0" aria-hidden />
      {label}
    </span>
  );
}
